<div *ngIf="offerLogin">To view {{ label }}, <a href="" (click)="openDialogue()">click here</a></div>
<div *ngIf="!hasNcarbNumber">No {{ label }} to view: {{ name }} does not have an associated NCARB Record Number.</div>
